import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tick, setTick] = useState(0);
  const [soundOn, setSoundOn] = useState(localStorage.getItem("ypb_sound") !== "off");
  const bump = () => setTick((t) => t + 1);
  const toggleSound = () => {
    const v = !soundOn;
    setSoundOn(v);
    localStorage.setItem("ypb_sound", v ? "on" : "off");
    if (v && window.speechSynthesis) window.speechSynthesis.speak(new SpeechSynthesisUtterance("Sound on"));
  };

  const refresh = async () => {
    if (!localStorage.getItem("ypb_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ypb_token");
      setUser(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ypb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ypb_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, refresh, tick, bump, soundOn, toggleSound }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}
